export const APP_LOGO =
  'https://cdn.shopify.com/app-store/listing_images/b4cbee22295ba0ec0d6538ebb0fc25f4/icon/CLOh2sjy2YwDEAE=.png';

export const APP_NAME = 'ZonStaff';
export const APP_TAGLINE = 'Staff Management';
